import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'mtm-loading-spinner',
  standalone: true,
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent {
  @Input() size: number = 24; // px
  @Input() borderWidth: number = 3; // px
  @Input() color: string = '#FF6B00';
  @Input() label: string | null = null;
  @Input() ariaLabel: string = 'Loading';
  @Input() textColor: string = '#6b7280';

  get ringStyles(): Record<string, string> {
    const mask: string = `radial-gradient(farthest-side, transparent calc(100% - ${this.borderWidth}px), black calc(100% - ${this.borderWidth}px))`;
    return {
      width: `${this.size}px`,
      height: `${this.size}px`,
      background: `conic-gradient(from 90deg, ${this.color} 0deg, ${this.color} 63deg, transparent 360deg)`,
      '-webkit-mask': mask,
      mask,
    };
  }
}


